module.exports = __webpack_public_path__ + "img/testimoni-bu-nadia-surgaina.e7e1933f.jpeg";